'use client';

import { useContext, useEffect, useRef, useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { notShowPreloderUrlPath } from './MainLoader';
import { TransitionContext } from '../../providers/transition';

export const useMainPreloader = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { href } = useContext(TransitionContext);

  const pathnameRef = useRef(pathname);
  pathnameRef.current = pathname;

  const timerRef = useRef<null | ReturnType<typeof setTimeout>>(null);

  const [routerIsLoading, setRouterIsLoading] = useState(false);

  useEffect(() => {
    // do not show the main preloader if sorting and filtering are used (the root URL does not change)
    const transitionUrlArr = href.split('/').filter((el) => el !== '');
    const pathnameArr = href.split('/').filter((el) => el !== '');
    if (transitionUrlArr.length > 1) transitionUrlArr.shift();
    if (pathnameArr.length > 1) pathnameArr.shift();
    timerRef.current = setTimeout(() => {
      if (
        transitionUrlArr.length > 0 &&
        pathnameArr.length > 0 &&
        notShowPreloderUrlPath.includes(pathnameArr[0]) &&
        notShowPreloderUrlPath.includes(transitionUrlArr[0]) &&
        transitionUrlArr[0] === pathnameArr[0]
      ) {
        setRouterIsLoading(false);
      } else {
        setRouterIsLoading(true);
      }
    }, 500);
  }, [href]);

  useEffect(() => {
    setRouterIsLoading(false);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  }, [pathname, searchParams]);

  return { routerIsLoading };
};
